import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ChannelOpt = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M11 2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2V5H11V2Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12.9497 7.77772L15.6317 5.09574C15.9467 4.78076 15.7236 4.24219 15.2782 4.24219H9.20711C8.76165 4.24219 8.53857 4.78076 8.85355 5.09574L11.5355 7.77772C11.9261 8.16825 12.5592 8.16825 12.9497 7.77772Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 9C2.89543 9 2 9.89543 2 11V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V11C22 9.89543 21.1046 9 20 9H4ZM12 11C13.1216 11 14.1355 11.4617 14.8618 12.2053L12 15.0671L11.3657 14.4328C11.0533 14.1203 10.5468 14.1203 10.2344 14.4328C9.92194 14.7452 9.92194 15.2517 10.2344 15.5641L11.4344 16.7641C11.7468 17.0765 12.2533 17.0765 12.5657 16.7641L15.7432 13.5867C15.9092 14.0261 16 14.5025 16 15C16 17.2091 14.2091 19 12 19C9.79086 19 8 17.2091 8 15C8 12.7909 9.79086 11 12 11Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
